import React, { createContext, useCallback, useContext, useState } from 'react';

import Alert from '../components/Alert';

interface AlertContextData {
  showAlert(message: AlertMessage): void;
}

export interface AlertMessage {
  type: 'success' | 'error' | 'info';
  title: string;
  description: React.ReactNode;
}

const AlertContext = createContext<AlertContextData>({} as AlertContextData);

const AlertProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AlertMessage>({} as AlertMessage);

  const showAlert = useCallback(
    ({ type, title, description }: AlertMessage) => {
      const alert = {
        type,
        title,
        description,
      };

      setData(alert);
    },
    [],
  );

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <Alert data={data} />
    </AlertContext.Provider>
  );
};

function useAlert(): AlertContextData {
  const context = useContext(AlertContext);

  if (!context) {
    throw Error('useAlert must be used within a AlertProvider');
  }

  return context;
}

export { AlertProvider, useAlert };
